export default "__VITE_ASSET__aecb4ff5__"